import { Injectable } from '@angular/core';
import { ConfigurationOption } from './configuration.model';
import { ApiConfiguration } from '../api/api.model';
import { SettingConfiguration } from '../setting/setting-configuration.model';
import { ExcelConfiguration } from '../excel/excel.model';
import { GridConfiguration } from '../../controls/grid-control/models/grid-configuration.model';
import { TranslateConfiguration } from '../translate/translate.model';
@Injectable({
  providedIn: 'root'
})
export class ConfigurationService {
  private option: ConfigurationOption;

  constructor() {
  }
  setConfig(configurationOption: ConfigurationOption) {
    this.option = configurationOption;
  }

  getApiConfiguration(): ApiConfiguration {
    this.option = this.option || {};
    this.option.api = this.option.api || {};
    this.option.api.host = this.option.api.host || location.origin;
    this.option.api.localStorageKey = this.option.api.localStorageKey || 'a9b9b57f-cfea-49d8-988b-9e96f486b7c4';
    this.option.api.tokenHeaderKey = this.option.api.tokenHeaderKey || 'Token';
    return this.option.api;
  }

  getExcelConfiguration(): ExcelConfiguration {
    if (this.option && this.option.excel) {
      return this.option.excel;
    }
    return null;
  }

  getSettingConfiguration(): SettingConfiguration {
    if (this.option && this.option.setting) {
      return this.option.setting;
    }
    return null;
  }

  getGridConfiguration(): GridConfiguration {
    if (this.option && this.option.grid) {
      return this.option.grid;
    }
    return null;
  }

  getTranslateConfiguration(): TranslateConfiguration {
    return this.option?.translate;
  }
}
